import { defineAction } from '~/prix'
import citizenMockAction from './citizenMock.action.json' with { type: 'json' }
import { z } from 'zod'

const citizenMockDefinition = defineAction({
  ...citizenMockAction,

  input: z.object({
    seed: z.number().optional(),
    count: z.number().optional(),
    generateResponsible: z.boolean().optional(),
    maxCitizenCount: z.number().optional(),
  }),
  output: z.object({}),
})

export default citizenMockDefinition
